var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-logo"},[(_vm.customLogoExists)?_c('img',{attrs:{"src":_vm.customLogoPath,"alt":_vm.projectName}}):_c('div',{staticClass:"logo",class:{ running: _vm.running },on:{"animationiteration":_vm.checkRunning}})])}
var staticRenderFns = []

export { render, staticRenderFns }